import { makeVar } from '@apollo/client';

export interface IRecommendedGoalsBySpecializedMajors {
  academicProgramId: string;
  academicProgramName: string;
  match: {
    name: string;
    match: number;
    jobTitleId: string;
  }[];
}

export interface IRecommendedGoalsBySpecializedMajorsCache {
  error: string;
  data: IRecommendedGoalsBySpecializedMajors[] | undefined;
}

export const emptyRecommendedGoalsBySpecializedMajorsCache: IRecommendedGoalsBySpecializedMajorsCache = {
  error: '',
  data: undefined,
};

export const RecommendedGoalsBySpecializedMajorsReactiveVar = makeVar<IRecommendedGoalsBySpecializedMajorsCache>(
  emptyRecommendedGoalsBySpecializedMajorsCache,
);
